import React, { useState } from 'react'
import FormOdooAccount from './FormAccount'
import ModalBox from '../../ui/ModalBox'
import { Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const AddOdooAccount = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };

  const handleSuccess = () => {
    setOpen(true);
  };
  return (
    <>
      <Typography variant="Poster" component="h4" gutterBottom
      >
        Add New Account
      </Typography>
      <FormOdooAccount handleSuccess={handleSuccess} />
      <ModalBox
        open={open}
        handleClose={handleClose}
        text="The add operation has been completed successfully.. You added new account"
        name="Gate"
      />
    </>
  )
}

export default AddOdooAccount